import { useEffect, useRef } from 'react';
import {
  useSubjectMeta,
  useSubjectId,
  UseSubjectMetaSelector
} from '@surveycake/react-logic-engine';
import { Message, MessageInstance } from '@surveycake/rc';
import { useSurveyConfig } from 'app/core/survey-config';
import { t } from 'app/shared/i18n';

const timerSelector: UseSubjectMetaSelector<number> = meta => meta.timer;

export function useTimerCounter() {
  const id = useSubjectId();
  const timer = useSubjectMeta(id, timerSelector);
  const messageInstanceRef = useRef<MessageInstance>();
  const { wording } = useSurveyConfig();

  useEffect(() => {
    if (timer === 0 && messageInstanceRef.current) {
      messageInstanceRef.current.destroy();
      messageInstanceRef.current = undefined;
    } else if (timer > 0) {
      const content = t(wording.module.timer.countdown, { sec: timer });
      if (messageInstanceRef.current) {
        messageInstanceRef.current.update(content);
      } else {
        messageInstanceRef.current = Message.info(content);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timer]);
}
